import {createSlice} from "@reduxjs/toolkit";

const initialUsersState = {
  listLoading: false,
  totalUsersCount: 0,
  pageCount: 0,
  entities: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const customersSlice = createSlice({
  name: "customers",
  initialState: initialUsersState,
  reducers: {
    customersFetched: (state, action) => {
      const {totalUsersCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalUsersCount = totalUsersCount;
      state.pageCount = pageCount;
    },
    customersAppended: (state, action) => {
      const {totalUsersCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.totalUsersCount = totalUsersCount;
      state.pageCount = pageCount;
    },
    addEditCommission: (state, action) => {
      const {customerID, commission} = action.payload;
      const mappedArray = state.entities.map(item => item.customerID);
      const index = mappedArray.indexOf(customerID);
      if (Boolean(state.entities)) {
        state.entities[index].commission = commission
      }
    },
    updateCustomerData: (state, action) => {
      const {customerID, data} = action.payload;
      const {
        firstName,
        lastName,
        city,
        street,
        phoneNumbers,
        email,
        allowInvoiceDeal
      } = data;
      const mappedArray = state.entities.map(item => item.customerID);
      const index = mappedArray.indexOf(customerID);
      if (Boolean(state.entities)) {
        state.entities[index].firstName = firstName;
        state.entities[index].lastName = lastName;
        state.entities[index].address.primary.city = city;
        state.entities[index].address.primary.street = street;
        state.entities[index].phoneNumbers = phoneNumbers;
        state.entities[index].email = email;
        state.entities[index].allowInvoiceDeal = allowInvoiceDeal;
      }
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.invoicesError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
